import { SignedIn, SignedOut } from '@clerk/clerk-react';

/**
 * Legacy vendor login without invite. Booths are invite-only now.
 */
export default function VendorLogin() {
  return (
    <div className="flex flex-col gap-6">
      <h1 className="text-3xl font-semibold">Vendor onboarding</h1>
      <SignedOut>
        <p className="text-lg text-slate-600 dark:text-slate-400">
          Vendors join with an invite link from their flea market owner. Open the link you were sent to sign in and set up your booth.
        </p>
      </SignedOut>
      <SignedIn>
        <p className="text-lg text-slate-600 dark:text-slate-400">
          You’re signed in, but joining requires an invite link from your market owner (or the app admin). Ask them to send you a new onboarding link.
        </p>
      </SignedIn>
    </div>
  );
}
